<form #theForm="ngForm" (ngSubmit)="ok(theForm.value)">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      <span>Save grid configuration</span>
    </h4>
  </div>

  <div class="form-group modal-body">
    <div class="container-fluid">

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Name</label>
            <input #fcName="ngModel" name="name" class="form-control" [ngModel]="viewState.Name" ngbAutofocus required
              [appBizGridNotInList]="getUsedViewStateNames()" />
              <div class="error" [class.invisible]="fcName.valid || fcName.pristine">
                @if (fcName.hasError('required')) {
                  <span>Required</span>
                }
                @if (fcName.hasError('appBizGridNotInList')) {
                  <span>Name is already used</span>
                }
              </div>
            </div>
          </div>
        </div>

        @if (viewStateWithTrackingFields) {
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div class="control control-checkbox lg control-form-group">
                  <label>
                    Show tracking fields
                    <input type="checkbox" name="showTrackingFields" [ngModel]="viewState.ShowTrackingFields" class="form-control" />
                    <i></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        }

      </div>
    </div>

    <div class="modal-footer">
      <div class="text-center">
        <button type="submit" class="btn btn-primary mw-12" [disabled]="theForm.invalid">OK</button>
        <button type="button" class="btn btn-primary mw-12" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </form>
